var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { makeStyles } from "../../styles/index";
var html = {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    // Change from `box-sizing: content-box` so that `width`
    // is not affected by `padding` or `border`.
    boxSizing: 'border-box',
    // Fix font resize problem in iOS
    WebkitTextSizeAdjust: '100%',
    // Suppress highlights when tapping link elements.
    WebkitTapHighlightColor: 'transparent',
};
// @ts-ignore
var bodyStyles = function (theme) { return (__assign(__assign({ color: theme.palette.common.black }, theme.typography.body2), { backgroundColor: theme.palette.background.default, '@media print': {
        // Save printer ink.
        backgroundColor: theme.palette.common.white,
    } })); };
var styles = function (theme) { return ({
    '@global': {
        '@font-face': [
            {
                fontFamily: 'MJS-GJShinMGoProN',
                fontDisplay: 'swap',
                fontStyle: 'normal',
                fontWeight: 'normal',
                src: "\n                    local('MJS-GJShinMGoProN'),\n                    url('/fonts/MJS-GJShinMGoProN-Regular.woff') format('woff')\n                ",
            },
            {
                fontFamily: 'MJS-GJShinMGoProN',
                fontDisplay: 'swap',
                fontStyle: 'normal',
                fontWeight: 'bold',
                src: "\n                    local('MJS-GJShinMGoProN'),\n                    url('/fonts/MJS-GJShinMGoProN-DeBold.woff') format('woff')\n                ",
            },
        ],
        html: html,
        '*, *::before, *::after': {
            boxSizing: 'inherit',
            fontFamily: theme.typography.fontFamily,
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold,
        },
        body: __assign(__assign({ margin: 0 }, bodyStyles(theme)), { fontSize: theme.typography.fontSize, 
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: theme.palette.background.default,
            } }),
    },
}); };
var useStyles = makeStyles(styles, { name: 'SnCssBaseline' });
export var CssBaseline = function (props) {
    var _a = props.children, children = _a === void 0 ? null : _a;
    useStyles(props);
    // const className = classNames(classes?.root);
    return React.createElement(React.Fragment, null, children);
};
